export const userConfig = {
  dsvHorsensABC: '7brqXhTGkYzWwWEOoEzm',
  bunzlGreve: 'NdT1xdOn77UIMwqvttMG',
};
